<template>
  <section>
    <div
      v-for="(item, index) in listData"
      :key="index"
      class="text item"
      @click.stop="details(item)"
    >
      <div class="cl-card" v-if="item.type == 8">
        <div class="row clearfix">
          <div class="col-lg-3 col-md-4 col-sm-12 cl-card-image left">
            <img :src="item.images[0]" class="img-fluid" alt="" />
          </div>
          <div
            class="col-lg-9 col-md-8 col-sm-12 cl-card-main left"
            style="
              cursor: pointer;
              width: 608px;
              margin-left: 16px;
              position: relative;
              height: 128px;
            "
          >
            <h3 class="cl-card-main-title">
              <span>{{ item.tip }}</span
              ><span v-if="item.use_type == '0'">{{ $t("全款") }}</span
              ><span v-if="item.use_type == '1'">{{ $t("分期") }}</span
              >{{ item.title }}
            </h3>
            <div class="cl-card-main-info">{{ item.year }} | {{ item.km }}</div>
            <div class="cl-card-main-info" style="margin-top: 10px">
              <span v-for="(child, key1) in item.tips_arr" :key="key1">{{ child }} </span>
            </div>

            <div class="jine" v-if="item.my_type == '0'">${{ item.price }}</div>
            <div class="jine" v-if="item.my_type == '1'">{{ $t("面议") }}</div>
          </div>
        </div>
        <div class="row clearfix" style="margin-top: 20px">
          <div
            class="col-lg-9 col-md-8 col-sm-12 cl-card-main left"
            style="width: 510px; height: 24px; line-height: 24px"
          >
            <div class="left img"><img :src="item.head_img" alt="" /></div>
            <div class="left" style="margin: 0 8px; color: #666666; font-size: 14px">
              {{ item.user_nickname }}
            </div>
            <div
              class="left"
              style="
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
              "
            >
              {{ item.create_time }}
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-12 right" style="color: #999999">
            <i class="el-icon-view"></i>
            <span>{{ item.see_number }}</span>
          </div>
        </div>
        <el-divider></el-divider>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "home",
  components: {},
  data() {
    return {};
  },
  props: ["listData"],
  created() {},
  methods: {
    //   二手车详情
    details(item) {
      console.log("item", item);
      this.$router.push({
        url: "/twoHandcartDetails",
        name: "twoHandcartDetails",
        query: { userId: item.article_id, report_article_type: 8 },
      });
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
@import "themePath/Monitor/cl-css";
@import "themePath/railscasts";
.new-right {
  margin-top: 0;
}

.cl-card-main-title {
  span {
    line-height: 21px;
    text-align: center;
    display: inline-block;
    // width: 52px;
    height: 21px;
    background: #4ab7fa;
    border-radius: 2px 2px 2px 2px;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    margin-right: 8px;
    color: #ffffff !important;
    padding: 0 6px;
  }
  span:nth-child(2) {
    // width: 40px;
    height: 21px;
    line-height: 21px;
    text-align: center;
    background: transparent;
    display: inline-block;
    border: 1px solid #4ab7fa;
    border-radius: 2px 2px 2px 2px;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #4ab7fa !important;
  }
}
.imgList {
  .cl-card-main-info {
    width: 808px;
    overflow: hidden; /*文本超出隐藏*/
    text-overflow: ellipsis; /*文本超出显示省略号*/
    white-space: nowrap; /*超出的空白区域不换行*/
    height: auto;
    margin: 0 0 8px 0;
    color: #666666;
  }
  li {
    width: 248px;
    img {
      width: 100%;
      height: 172px;
    }
  }
}
.cl-card {
  padding: 0;
}
.cl-card .cl-card-image {
  // height: 128px;
}
.jine {
  position: absolute;
  bottom: 0;
  font-size: 22px;
  font-family: Circular-Bold, Circular;
  font-weight: bold;
  color: #ff1717;
}
.cl-card-main-info {
  margin: 0;
  height: 22px;
  margin-bottm: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/twoHandcart.vue